<template>
  <el-dialog :visible.sync="visible_v" title="导出历史变更记录"
             width="1400px"
             @close="cancel">
    <div class="companyBox">
      <Form v-if="select == false" ref="searchForm" :label-width="90" :model="formCustom" inline>
        <Form-item label="变更日期：">
          <el-date-picker
            v-model="formCustom.createTimes"
            end-placeholder="结束日期"
            start-placeholder="开始日期"
            type="daterange">
          </el-date-picker>
        </Form-item>
        <Form-item label="变更类型：">
          <Select v-model="formCustom.bglx" clearable filterable style="width: 200px">
            <Option value="新增">新增</Option>
            <Option value="更新">更新</Option>
          </Select>
        </Form-item>
        <Form-item label="变更内容：">
          <Input
            v-model="formCustom.bgnr"
            :maxlength="50"
            clearable
            style="width: 200px"
          ></Input>
        </Form-item>
        <Form-item label="员工编号：">
          <Input
            v-model="formCustom.zgbh"
            :maxlength="50"
            clearable
            style="width: 200px"
          ></Input>
        </Form-item>
        <Form-item label="姓名：">
          <Input
            v-model="formCustom.zgxm"
            :maxlength="50"
            clearable
            style="width: 200px"
          ></Input>
        </Form-item>
        <Form-item label="家属姓名：">
          <Input
            v-model="formCustom.jsxm"
            :maxlength="50"
            clearable
            style="width: 200px"
          ></Input>
        </Form-item>
        <Form-item label="状态：">
          <Select v-model="formCustom.auditStatus" clearable filterable style="width: 200px">
            <Option :value="1">已确定</Option>
            <Option :value="0">未确定</Option>
          </Select>
        </Form-item>
        <Form-item>
          <Button type="primary" @click="handleSearch">查询</Button>
          <Button class="iviewButton" @click="handleReset('searchForm')"
          >重置
          </Button
          >
        </Form-item>
      </Form>
      <div style="margin-bottom: 20px">
        <Button :loading="loadingDownload" style="margin-left: 10px;" type="primary" @click="downloademployeeRecord">
          导出
        </Button>
      </div>
      <div>
        <Table
          :columns="companyColumns"
          :data="companyTableData"
          :loading="loading"
          aria-describedby=""
          aria-hidden="true"
          border
          @on-selection-change="selectionChange"
        >
          <template slot="action" slot-scope="{ row }">
            <Button
              v-if="row.auditStatus == 0"
              size="small"
              type="text"
              @click="goDetermine(row)"
            >去确定
            </Button>
          </template>
          <template slot="auditStatus" slot-scope="{ row }">
            <p>{{
                row.auditStatus == 0 ? '未确定' : row.auditStatus == 1 ? '已确定' : '已复核'
              }}</p>
          </template>
        </Table>
        <Page
          ref="pages"
          :current="page"
          :total="total"
          class="page_position"
          show-elevator
          show-sizer
          show-total
          @on-change="setCurrent"
          @on-page-size-change="setPage"
        ></Page>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import permissionList from "@/libs/handlePermission.ts";
import axios from "axios";
import addforeignEmployess from "./addforeignEmployess.vue"
import {employeeChangeLogAudit, employeeChangeLogPage} from "@/api/employee";

export default {
  props: {
    visible: {
      type: Boolean,
      required: false
    },
    model: {
      type: Object,
      default: () => null
    },
    select: {
      type: Boolean,
      required: false
    },
  },
  watch: {
    visible(v) {
      console.log(v)
      this.visible_v = v
      if (v) {
        this.init()
      }
    }
  },
  name: "company",
  data() {
    return {
      loadingDownload: false,
      visible_v: false,
      absenteeismUrl: '',
      dialogFormVisible: false,
      visibleAdd: false,
      visibleFillIn: false,
      addRow: {},
      dialogVisible: false,
      dialogTableVisible: false,
      dialogWorkerVisible: false,
      tableData: [],
      total: 0,
      page: 1,
      dialogtotal: 0,
      dialogpage: 1,
      dialogloading: false,
      dialogWorkerloading: false,
      tableWorkerData: [],
      size: 10,
      pageSize: 10,
      loading: false, // 表格等待
      btnList: [],
      companyIds: "",
      formCustomTable: {},
      formCustom: {},
      asyncRoute: {
        pass: '1',
        checkIdea: ''
      },
      companyColumns: [
        {type: "index", title: "序号", align: "center"},
        {title: "员工编号", key: "zgbh", align: "center"},
        {title: "姓名", key: "zgxm", align: "center"},
        {title: "家属姓名", key: "jsxm", align: "center"},
        {title: "变更日期", key: "createTime", align: "center"},
        {title: "变更类型", key: "bglx", align: "center"},
        {title: "变更人", key: "createUserName", align: "center"},
        {title: "变更内容", key: "bgnr", align: "center", width: '150px'},
        {title: "变更前", key: "bgq", align: "center", width: '150px'},
        {title: "变更后", key: "bgh", align: "center", width: '150px'},
        {title: "状态", key: "auditStatus", slot: "auditStatus", align: "center"},
        {title: "操作", slot: "action", align: "center", fixed: "right"},
      ],
      companyTableData: [], // 表格数据
      row: {},
      areaData: [],
      countyCode: "",
      industryTypeList: [], // 行业类型
      companyScaleList: [], // 企业规模
      addDialogVisible: false,
      editDialogVisible: false,
      dialogAuditVisible: false,
      roleType: '',
      companyAttendanceIds: '',
      val: new Date(),
      daylist: [],
      holidaylist: [],
      cutoffTime: '',
      isupload: false,
      workerRow: {},
      employeerow: {},
      isuploadWorker: false,
      attendanceDate: '',
      BaseUrl: process.env.VUE_APP_BASE_URL,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("getToken"),
      },
      upAction: this.$getImg + 'api/auth/file', // 上传图片网址
      getToken: {Authorization: 'Bearer ' + localStorage.getToken},
      datarow: {},
    }
  },
  components: {
    addforeignEmployess
  },
  mounted() {
    const list = JSON.parse(localStorage.getItem("routerList"))
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList()
    this.init()
    let token = localStorage.getItem('getToken')
    let userString = decodeURIComponent((window.atob(token.split('.')[1].replace(/-/g, "+").replace(/_/g, "/"))))
    let user = JSON.parse(userString);
    this.roleType = user.roleType;
    console.log(this.roleType)
  },
  methods: {
    downloadFile(row) {
      window.open(row.templatePath)
    },
    uploadFile(row) {
      this.workerRow = row
      if (this.$refs.upload != undefined) {
        this.$refs["upload"].clearFiles()
      }
      this.dialogFormVisible = true
      this.absenteeismUrl = ''
    },
    handleSuccess(response) {
      this.absenteeismUrl = this.$getImgFile + response.data
    },
    handleError(error, file) {
      this.$message.error(file.msg)
    },
    // 超出限制大小
    handleMaxSize() {
      this.$message.error('所传图片不能超过2M,请重新选择')
    },
    // 验证失败钩子
    handleFormatError() {
      this.$message.error('请上传正确的图片格式，仅支持jpg，jpeg，png三种格式')
    },
    cancelAudit() {
      this.dialogAuditVisible = false
      // this.asyncRoute.checkIdea = ''
    },
    auditWorker(row) {
      this.$confirmss('确认提交审核？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        companyEvaluationEmployeeRecordSubmitAudit({companyEvaluationEmployeeRecordId: row.companyEvaluationEmployeeRecordId}).then((res) => {
          if (res.data.success === false) {
            this.$message.warning(res.data.msg)
          } else {
            this.$message.success(res.data.msg)
            this.handleSearchWorker()
          }
          this.init()
        }).catch((error) => {
          this.$message.error(error.response.data.msg)
        })
      }).catch(() => {
        this.$message.info('已取消')
      })
    },
    successadd() {
      this.init()
      this.visibleAdd = false
    },
    addEvaluation() {
      this.addRow = {}
      this.isupload = false
      this.select = false
      this.visibleAdd = true
    },
    save() {
      this.visibleFillIn = false
      this.handleSearchWorker()
    },
    handleCancelAdd() {
      this.visibleAdd = false
    },
    gofillIn(row) {
      this.row = row
      this.visibleFillIn = true
    },
    handleCancelFillIn() {
      this.visibleFillIn = false
    },
    // 初始化
    init() {
      this.loading = true
      let params = {}
      if (this.formCustom.createTimes) {
        params.createTimeStart = this.$moment(this.formCustom.createTimes[0]).format("YYYY-MM-DD")
        params.createTimeEnd = this.$moment(this.formCustom.createTimes[1]).format("YYYY-MM-DD")
      }
      if (this.formCustom.bglx) params.bglx = this.formCustom.bglx
      if (this.formCustom.bgnr) params.bgnr = this.formCustom.bgnr
      if (this.formCustom.zgbh) params.zgbh = this.formCustom.zgbh
      if (this.formCustom.zgxm) params.zgxm = this.formCustom.zgxm
      if (this.formCustom.jsxm) params.jsxm = this.formCustom.jsxm
      params.auditStatus = this.formCustom.auditStatus
      if (this.select) params.employeeId = this.model.employeeId
      employeeChangeLogPage({
        current: 1,
        size: 10,
        ...params
      }).then((res) => {
        this.changeData(res);
      });
    },
    selectionChange(rows) {
      if (rows && rows.length > 0) {
        let ids = [];
        console.log(rows)
        rows.forEach((row) => {
          ids.push(row.companyAttendanceId);
        });
        this.companyAttendanceIds = ids.join(",");
      } else {
        this.companyAttendanceIds = ''
      }
    },
    check(row) {//查看详情
      this.addRow = row
      this.isupload = true
      this.visibleAdd = true
      this.select = true
    },
    checks(row) {//编辑详情
      this.addRow = row
      this.isupload = true
      this.select = false
      this.visibleAdd = true
    },
    goEmployee(row) {//查看职工
      this.row = row
      this.dialogTableVisible = true
      pageCompanyEvaluationEmployee({
        companyEvaluationId: row.companyEvaluationId,
        current: 1,
        size: 10
      }).then((res) => {
        this.dialogchangeData(res);
      });
    },
    checkWorker(row) {//查看职工详情
      this.employeerow = row
      this.dialogWorkerVisible = true
      companyEvaluationEmployeeRecordPage({
        companyEvaluationEmployeeId: row.companyEvaluationEmployeeId,
        current: 1,
        size: 10
      }).then((res) => {
        this.dialogWorkerchangeData(res);
      });
    },

    checksWorker(row) {//查看详情
      this.workerRow = row
      this.visibleFillIn = true
    },
    deleteEvaluation(row) {
      this.$Modal.confirm({
        title: '确认删除？',
        onOk: () => {
          companyEvaluationDelete({companyEvaluationId: row.companyEvaluationId}).then((res) => {
            if (res.data.success === false) {
              this.$message.warning(res.data.msg)
            } else {
              this.$message.success(res.data.msg)
            }
            this.init()
          }).catch((error) => {
            this.$message.error(error.response.data.msg)
          })
        },
        onCancel: () => {
          this.$message.info('已取消删除')
        }
      })
    },
    // 查询
    handleSearch() {
      this.loading = true
      let params = {}
      console.log(this.formCustom)
      if (this.formCustom.createTimes) {
        params.createTimeStart = this.$moment(this.formCustom.createTimes[0]).format("YYYY-MM-DD")
        params.createTimeEnd = this.$moment(this.formCustom.createTimes[1]).format("YYYY-MM-DD")
        console.log(this.$moment(this.formCustom.createTimes[0]).format("YYYY-MM-DD"))
      }
      console.log(params)
      if (this.formCustom.bglx) params.bglx = this.formCustom.bglx
      if (this.formCustom.bgnr) params.bgnr = this.formCustom.bgnr
      if (this.formCustom.zgbh) params.zgbh = this.formCustom.zgbh
      if (this.formCustom.zgxm) params.zgxm = this.formCustom.zgxm
      if (this.formCustom.jsxm) params.jsxm = this.formCustom.jsxm
      params.auditStatus = this.formCustom.auditStatus
      if (this.select) params.employeeId = this.model.employeeId

      employeeChangeLogPage({
        current: 1,
        size: this.pageSize,
        ...params
      }).then((res) => {
        this.changeData(res);
        this.$refs["pages"].currentPage = 1; // 分页变成第一页
      });
    },

    // 调接口获取表格数据
    changeData(res) {
      this.total = res.data.data.total;
      this.size = res.data.data.size;
      this.companyTableData = res.data.data.records;
      this.loading = false;
    },
    dialogchangeData(res) {
      this.dialogtotal = res.data.data.total;
      this.dialogsize = res.data.data.size;
      this.tableData = res.data.data.records;
      this.dialogloading = false;
    },
    dialogWorkerchangeData(res) {
      this.dialogWorkertotal = res.data.data.total;
      this.dialogWorkersize = res.data.data.size;
      this.tableWorkerData = res.data.data.records;
      this.dialogWorkerloading = false;
    },
    // 重置
    handleReset(name) {
      this.$refs[name].resetFields();
      this.formCustom = {}
      // 重置查询条件会再次查询
      this.handleSearch();
    },
    // 改变页码
    dialogsetCurrent(val) {
      this.dialogloading = true;
      this.dialogpage = val;
      pageCompanyEvaluationEmployee({
        current: val,
        size: this.pageSize,
        ...this.formCustom
      }).then((res) => {
        this.dialogchangeData(res);
      });
    },
    // 改变每页条数
    dialogsetPage(val) {
      this.dialogloading = true;
      this.pageSize = val;
      pageCompanyEvaluationEmployee({
        current: 1,
        size: this.pageSize,
        ...this.formCustom
      }).then((res) => {
        this.dialogchangeData(res);
        this.$refs["dialogpages"].currentPage = 1; // 分页变成第一页
      });
    },
    setCurrent(val) {
      this.loading = true
      this.loading = true;
      this.page = val;
      let params = {}
      if (this.formCustom.createTimes) {
        params.createTimeStart = this.$moment(this.formCustom.createTimes[0]).format("YYYY-MM-DD")
        params.createTimeEnd = this.$moment(this.formCustom.createTimes[1]).format("YYYY-MM-DD")
      }
      if (this.formCustom.bglx) params.bglx = this.formCustom.bglx
      if (this.formCustom.bgnr) params.bgnr = this.formCustom.bgnr
      if (this.formCustom.zgbh) params.zgbh = this.formCustom.zgbh
      if (this.formCustom.zgxm) params.zgxm = this.formCustom.zgxm
      if (this.formCustom.jsxm) params.jsxm = this.formCustom.jsxm
      params.auditStatus = this.formCustom.auditStatus
      if (this.select) params.employeeId = this.model.employeeId
      employeeChangeLogPage({
        current: val,
        size: this.pageSize,
        ...params,
      }).then((res) => {
        this.changeData(res);
      });
    },
    // 改变每页条数
    setPage(val) {
      this.loading = true
      this.loading = true;
      this.pageSize = val;
      let params = {}
      if (this.formCustom.createTimes) {
        params.createTimeStart = this.$moment(this.formCustom.createTimes[0]).format("YYYY-MM-DD")
        params.createTimeEnd = this.$moment(this.formCustom.createTimes[1]).format("YYYY-MM-DD")
      }
      if (this.formCustom.bglx) params.bglx = this.formCustom.bglx
      if (this.formCustom.bgnr) params.bgnr = this.formCustom.bgnr
      if (this.formCustom.zgbh) params.zgbh = this.formCustom.zgbh
      if (this.formCustom.zgxm) params.zgxm = this.formCustom.zgxm
      if (this.formCustom.jsxm) params.jsxm = this.formCustom.jsxm
      params.auditStatus = this.formCustom.auditStatus
      if (this.select) params.employeeId = this.model.employeeId
      employeeChangeLogPage({
        current: 1,
        size: this.pageSize,
        ...params,
      }).then((res) => {
        this.changeData(res);
        this.$refs["pages"].currentPage = 1; // 分页变成第一页
      });
    },
    publish(row) {
      companyEvaluationPublish({companyEvaluationId: row.companyEvaluationId}).then(res => {
        if (res.data.success) {
          this.$message.success('发布成功')
          this.init()
        }
      }).catch(error => {
        this.$message.error(error.response.data.msg)
      })
    },
    downloademployeeRecord() {
      this.loadingDownload = true
      let params = {}
      if (this.formCustom.createTimes) {
        params.createTimeStart = this.$moment(this.formCustom.createTimes[0]).format("YYYY-MM-DD")
        params.createTimeEnd = this.$moment(this.formCustom.createTimes[1]).format("YYYY-MM-DD")
      }
      if (this.formCustom.bglx) params.bglx = this.formCustom.bglx
      if (this.formCustom.bgnr) params.bgnr = this.formCustom.bgnr
      if (this.formCustom.zgbh) params.zgbh = this.formCustom.zgbh
      if (this.formCustom.zgxm) params.zgxm = this.formCustom.zgxm
      if (this.formCustom.jsxm) params.jsxm = this.formCustom.jsxm
      params.auditStatus = this.formCustom.auditStatus
      if (this.select) params.employeeId = this.model.employeeId
      axios({
        baseURL: process.env.VUE_APP_BASE_URL,
        url: `org/auth/employeeChangeLog/export`,
        responseType: "blob",
        params: params,
        method: "get",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("getToken"),
        },
      }).then((res) => {
        this.loadingDownload = false
        const link = document.createElement("a");
        const blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
        link.download = this.$moment(new Date()).format("YYYYMMDDHHmm");
        link.href = URL.createObjectURL(blob);
        link.download = '历史变更记录.xlsx' // 下载的文件名
        link.click();
      }).catch(error => {
        this.addloading = false
        this.$message.error(error.response.request.status + '导出失败');
      })
    },
    cancel() {
      this.formCustom = {}
      this.$emit('cancel')
    },
    audit(row) {
      employeeChangeLogAudit({subjectId: row.employeeChangeLogId, pass: true}).then(res => {
        if (res.data.success) {
          this.$message.success('成功')
          this.init()
          this.$emit('successadd')
        }
      }).catch(error => {
        this.$message.error(error.response.data.msg)
      })
    },
    goDetermine(row) {
      this.$confirmss('是否确定?', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '去修改',
        cancelButtonText: '确定',
        type: 'warning'
      }).then(() => {
        if (this.select) {
          console.log(row)
          this.$emit('cancel', row)
        } else {
          this.$emit('put', row)
        }
      }).catch(action => {
        if (action === 'cancel') {
          this.audit(row)
        }
      })
    }
  }
}
</script>
<style lang="less">
.red {
  background-color: rgba(243, 12, 1, 0.48);
  color: rgb(0, 0, 0);
  padding: 8px;
}

.green {
  background-color: rgba(66, 165, 111, 0.5);
  padding: 8px;
  color: rgba(55, 55, 55);
}

.el-calendar-table td .el-calendar-day {
  padding: 0;
}

.el-calendar__header {
  display: none
}
</style>
